import { Link } from "react-router-dom";
import { movies, tvShows } from "@/mocks/media";
import MovieCard from "@/components/base/MovieCard";

export default function NotFound() {
  const suggestions = [...movies, ...tvShows]
    .sort((a, b) => b.views - a.views)
    .slice(0, 4);

  return (
    <div className="w-full px-4 md:px-8 py-16 md:py-24 min-h-[60vh] flex flex-col items-center">
      <span className="w-20 h-20 flex items-center justify-center rounded-2xl bg-background-100 border border-background-300 mb-6">
        <i className="ri-emotion-sad-line text-4xl text-primary-400"></i>
      </span>
      <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
        404 · 内容不存在
      </h1>
      <p className="text-sm md:text-base text-foreground-600 mb-8 text-center max-w-md">
        抱歉，你访问的页面可能已被移除或链接有误。不妨返回首页，或看看下面这些热门影片。
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3 mb-12">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-400 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-secondary-400 text-foreground-800 text-sm font-medium hover:bg-secondary-500/20 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-search-line"></i>
          去搜索影片
        </Link>
      </div>

      <div className="w-full max-w-4xl">
        <h2 className="text-lg font-semibold text-foreground-900 mb-5 text-center">为你推荐</h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
          {suggestions.map((item) => (
            <MovieCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
}